import { PropsWithChildren } from 'react';
import VolumesListProvider from '#/leaderboard/contexts/volumes-list';
import VolumesFilterProvider from '#/leaderboard/contexts/volumes-filter';

export default function LeaderboardVolumeProvider({
  children,
}: PropsWithChildren) {
  return (
    <VolumesFilterProvider>
      <VolumesListProvider>{children}</VolumesListProvider>
    </VolumesFilterProvider>
  );
}
